import { Module } from 'vuex'

import { RootState } from '@/store/types'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { PostcodeState } from './types'

const postcodeModule: Module<PostcodeState, RootState> = {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: {
    // TODO: Remove mapData since it's no longer needed can be replaced by postcode only
    mapData: JSON.parse(sessionStorage.getItem('mapData') || null) || {
      postcode: '',
      lat: '',
      lng: '',
    },
    postcodes: {},
  },
}

export default postcodeModule
